
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import { setResultModalData, showModal } from "../modal/modalSlice";

const initialState = {
    logList: [],
    logDataCount: 0,
    islemKayitItemReqResData: null,

    userDraftList: [],
    userDraftListCount: null,

    portalMemberData: null,
    isLoadingUpdatePortalMembersControl: false,

    panelUsers: [],
    panelUsersCount: 0,

    adminPanelNotifications: [],
    adminPanelNotificationsCount:null,
    selectPanelNotification: null,

    adminRentalCarSeekerList: [],
    adminRentalCarSeekercount: 0,

    adminKiralikAracList: [],
    adminKiralikAracCount: 0,

    adminDriverJobSeekerList: [],
    adminDriverJobSeekerCount: 0,

    adminDriverSeekerList: [],
    adminDriverSeekerCount: 0,

    adminSatilikAracList:[],
    adminSatilikAracCount: 0,

    adminBlockedUsers: [],
    blockedUsersCount: null,
    selectedBlockedUserAdmin: null,

    adminInspectionStationLocationList: [],
    selectedInspectionStation: null,
    selectedInspectionStationRoute: null,

    adminInspectionRoadRouteList: [],
    adminInspectionRoadRouteListCount: null,

    //! web
    webBlogList: [],
    selectedBlog: null,

    sendCashNotificationFromExcelResponseList: [],
    sendCashNotificationFromExcelResponseStatus: null,
    isLoadingSendCashNotificationFromExcel: false,
    
    isLoadingPanelUsers: false,
    isLoadingApproveDraft: false,
    isLoadingGetPanelUsersTopluExcel: false,
    isLoadingGetList:false,
    isLoadingAdd: false,
    isLoadingDelete: false,
    isLoadingUpdate: false,

    isLoadingGetIslemLog: false,

    isLoading: false,
    trailers: null,
    trucks: null,

    degerlendirmelerList: null,

    sevkiyatList: null,
    sevkiyatCount: null,


    isLoadingDeleteBlog: false,

    selectedBlogs: []

};

export const getIslemLog = createAsyncThunk("admin3/getIslemLog",async ({page, path, filterStartDate, filterEndDate, user, ipAddress, itemsPerPage}, thunkApi) => {
    try {

      //! filterStartDate(string)
      //! filterEndDate(string)
      //! ipAddress
      //! user
      //! path
      //! level
      //! page
      //! pageSize
      
      const { data } = await axiosInstance.get(`Logging/GetLogFilter?page=${page}&&path=${path}&&filterStartDate=${filterStartDate}&&filterEndDate=${filterEndDate}&&user=${user}&&ipAddress=${ipAddress}&&pageSize=${itemsPerPage}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const getPanelUsers = createAsyncThunk("admin3/getPanelUsers",async ({currentPage, firmaType}, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.get(`User/GetPanelUsers?sayfaSayisi=${currentPage}&&FirmaTypeId=${firmaType}`);
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

export const getPanelUsersTopluExcel = createAsyncThunk("admin3/getPanelUsersTopluExcel",async (_, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`User/GetPanelUsersExcel`);

    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

export const getAllRegisterDrafts = createAsyncThunk("admin3/getAllRegisterDrafts",async ({page, status}, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/Auth/GetAllRegisterDrafts?page=${page}&&status=${status}`);
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

  //! portal üye denetim güncelleme
  export const updatePortalMembersControl = createAsyncThunk("admin3/updatePortalMembersControl",async (body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.post(`/Auth/adminUpdateDraft`, body);
      if(data.statusCode === 200){
        thunkApi.dispatch(showModal("result"))
        thunkApi.dispatch(setResultModalData({msg: "Güncelleme işlemi başarılı bir şekilde gerçekleştirildi.", resultType: "success", btnText1: "Harika"}))
      }
      return data.data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: "Bir hata meydana geldi.", resultType: "error", btnText1: "Kapat"}))
      return thunkApi.rejectWithValue(error);
    }
  });

  


export const approveRegisterDraft = createAsyncThunk("admin3/approveRegisterDraft",async (body, thunkApi) => {
  try {
    const { data } = await axiosInstance.post(`/Auth/ApproveRegisterDraft`, body);
    if(data.message){
      thunkApi.dispatch(showModal("result"))
      thunkApi.dispatch(setResultModalData({msg: `Üye kayıt işlemi başarı ile ${body.isApproved ? "onaylandı" : "reddedildi"}.`, resultType: "success",  btnText1: "Listeyi Görüntüle"}))
    }
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);

  //! kiralık araç arayanlar
  export const getRentalCarSeekersAdmin = createAsyncThunk("admin3/getRentalCarSeekersAdmin",async ({vehicleType = "", workCity = "",  isAdvertiserCompany, isApproved = "", isActive="", page}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/Adverts/AdminGetAllRentVehicle?vehicleType=${vehicleType}&workCity=${workCity}&isAdvertiserCompany=${isAdvertiserCompany}&isApproved=${isApproved}&page=${page}&isActive=${isActive}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const approveRentalCarSeekerAdmin = createAsyncThunk("admin3/approveRentalCarSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminApproveRentVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Gerçekleşti.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kiralık araç arayanlar sil
  export const deleteRentalCarSeekerAdmin = createAsyncThunk("admin3/deleteRentalCarSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminDeleteRentVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Silindi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kiralık araç arayanlar güncelle
  export const updateRentalCarSeekerAdmin = createAsyncThunk("admin3/updateRentalCarSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminUpdateRentVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
   
  
  //! kiralık araç get
  export const getKiralikAracAdmin = createAsyncThunk("admin3/getKiralikAracAdmin",async ({workCity = "", vehicleType = "", advertisementCompany, isApproved = "", isActive = "", page}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/Adverts/AdminGetAllTruckVehicle?vehicleType=${vehicleType}&workCity=${workCity}&advertisementCompany=${advertisementCompany}&isApproved=${isApproved}&page=${page}&isActive=${isActive}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

//! kiralık araç onay
  export const adminKiralikAracAprove = createAsyncThunk("admin3/adminKiralikAracAprove",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminApproveTruckVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Gerçekleşti.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kiralık araç sil
  export const adminKiralikAracDelete = createAsyncThunk("admin3/adminKiralikAracDelete",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminDeleteTruckVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Silindi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

   //! kiralık araç güncelle
   export const adminKiralikAracUpdate = createAsyncThunk("admin3/adminKiralikAracUpdate",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminUpdateTruckVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! iş arayan sürücüler get
  
  export const getDriverJobSeekerAdmin = createAsyncThunk("admin3/getDriverJobSeekerAdmin",async ({workCity = "", page, isApproved = "", isActive = ""}, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/Adverts/AdminGetAllDriverJobSeeker?workCity=${workCity}&page=${page}&isApproved=${isApproved}&isActive=${isActive}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  //! iş arayan sürücüler onay
  export const approveDriverJobSeekerAdmin = createAsyncThunk("admin3/approveDriverJobSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminApproveDriverJobSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Gerçekleşti.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
   
  //! iş arayan sürücüler güncelleme
  export const updateDriverJobSeekerAdmin = createAsyncThunk("admin3/updateDriverJobSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminUpdateDriverJobSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
   
  //! iş arayan sürücüler silme
  export const deleteDriverJobSeekerAdmin = createAsyncThunk("admin3/deleteDriverJobSeekerAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminDeleteDriverJobSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Silindi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  
  
  
  //! sürücü arayanlar
  export const adminGetSurucuArayanlar = createAsyncThunk("admin3/adminGetSurucuArayanlar",async ({workCity = "", page, isActive = "", isApproved = ""}, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/Adverts/AdminGetAllDriverSeeker?workCity=${workCity}&page=${page}&isActive=${isActive}&isApproved=${isApproved}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  
  export const adminSurucuArayanAprove = createAsyncThunk("admin3/adminSurucuArayanAprove",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminApproveDriverSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Gerçekleşti.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const adminSurucuArayanUpdate = createAsyncThunk("admin3/adminSurucuArayanUpdate",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminUpdateDriverSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
   
  export const adminSurucuArayanDelete = createAsyncThunk("admin3/adminSurucuArayanDelete",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Adverts/AdminDeleteDriverSeeker`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Silindi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! satılık araç
  export const adminGetSatilikArac = createAsyncThunk("admin3/adminGetSatilikArac",async ({page}, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/TruckTrailer/GetAllAdminSaleVehicle?page=${page}`);
      
      return data; 
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  
  export const adminSatilikAracAprove = createAsyncThunk("admin3/adminSatilikAracAprove",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/TruckTrailer/UpdateAdminSaleVehicle`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Gerçekleşti.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  export const sendCashNotificationFromExcel = createAsyncThunk("admin3/sendCashNotificationFromExcel",async (excel, thunkApi) => {
    try {

      const file = new FormData();
      file.append("file", excel);

      const { data } = await axiosInstance.post(`/FirebaseNotification/SendCashNotificationFromExcel`, file);
      return data
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ 
        msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
        resultType: "error", 
        btnText1: "Listeye Dön",
      }));
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kamyoon web sitesi blog listesini çekme
  
  export const getBlogs = createAsyncThunk("admin3/getBlogs",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/Blog/GetListBlog`, body);
      
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

   //! kamyoon web sitesi blog detay çekme
  
   export const getBlogDetail = createAsyncThunk("admin3/getBlogDetail",async (slug, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/Blog/GetBlogBySlug?slug=${slug}`);
      
      return data?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kamyoon web sitesi blog listesine ekleme / güncelleme
  
  export const createBlog = createAsyncThunk("admin3/createBlog",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/CreateBlog`, body);
      
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      alert(error.response.data.ErrorDto.Errors[0])
      return thunkApi.rejectWithValue(error);
    }
  });

  //! Image kısmı null gelebilir. eğerki resim güncellenmeyecekse mutlaka null gelmelidir. resim güncellenecekse ozaman dolu gelebilir.  
  export const updateBlog = createAsyncThunk("admin3/updateBlog",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/UpdateBlog`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  export const deleteBlog = createAsyncThunk("admin3/deleteBlog",async (idList, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/DeleteBlog`, {ids: idList});
      
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Silme işlemi başarılı bir şekilde gerçekleştirildi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  
  //! kamyoon web sitesi blog listesine content alanı ekleme / güncelleme
  
  export const createBlogContent = createAsyncThunk("admin3/createBlogContent",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/CreateMainBlog`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! MainImage ve MainImageAlt null gelebilir aynı şekilde /Blog/UpdateMainBlog
  export const updateBlogContent = createAsyncThunk("admin3/updateBlogContent",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/UpdateMainBlog`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
    
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! kamyoon web sitesi blog listesine faq alanı oluşturma / güncelleme
  
  export const createBlogFAQ = createAsyncThunk("admin3/createBlogFAQ",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/CreateFaqBlog`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! Faqlar için güncelleme yapılır FaqImage buradada zorunlu değildir. 
  export const updateBlogFAQ = createAsyncThunk("admin3/updateBlogFAQ",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/Blog/UpdateFaqBlog`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  

  //! admin engellenen kullanıcılar
  export const addBlockedUserAdmin = createAsyncThunk("admin3/addBlockedUserAdmin", async(body , thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/RestrictedUsers/CreateRestrictedUser`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data.data.restrictedUsersDto

    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

  export const getBlockedUsersAdmin = createAsyncThunk("admin3/getBlockedUsers",async ({page, phoneNumber = "", fullNameTitle = "", nationalId = "", plate = "", savedByCompanyId = "", isReviewed}, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.get(`/RestrictedUsers/GetAllRestrictedUsersForAdmin?Page=${page}&phoneNumber=${phoneNumber}&fullNameTitle=${fullNameTitle}&nationalId=${nationalId}&plate=${plate}&savedByCompanyId=${savedByCompanyId}&isReviewed=${isReviewed}`);
      
      return data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const updateBlockedUsersAdmin = createAsyncThunk("admin3/updateBlockedUsersAdmin",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/RestrictedUsers/SetRestrictedUserStatus`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const copyBlockedUser = createAsyncThunk("admin3/copyBlockedUser",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/RestrictedUsers/CopyBlockedUser`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı Bir Şekilde Güncellendi.",
            resultType: "success",
            btnText1: "Listeyi Görüntüle",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  
  //! karayolları istasyonları getirme
  export const getAllInspectionStationLocation = createAsyncThunk("admin3/getAllInspectionStationLocation",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/InspectionStationLocations/GetAllInspectionStationLocation`, body);
      
      return data.data.$values;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! karayolları istasyonları ekleme
  export const createInspectionStationLocation = createAsyncThunk("admin3/createInspectionStationLocation",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/InspectionStationLocations/CreateInspectionStationLocation`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  //! karayolları istasyonları güncelleme
  export const updateInspectionStationLocation = createAsyncThunk("admin3/updateInspectionStationLocation",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/InspectionStationLocations/UpdateInspectionStationLocation`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde güncellendi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  
  //! karayolları istasyonları silme
  export const deleteInspectionStationLocation = createAsyncThunk("admin3/deleteInspectionStationLocation",async (body, thunkApi) => {
    try {
      
      const { data } = await axiosInstance.delete(`/InspectionStationLocations/DeleteInspectionStationLocation?id=${body.id}`);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde silindi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
      }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  
  //! karayolları istasyonları konum ekle
  export const createInspectionRoadRoute = createAsyncThunk("admin3/createInspectionRoadRoute",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/InspectionStationLocations/CreateRoadRoute`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  //! karayolları istasyonları konum get
  export const getAllInspectionRoadRoute = createAsyncThunk("admin3/getAllInspectionRoadRoute",async ({page, name = ""}, thunkApi) => {
    try {
      const { data } = await axiosInstance.get(`/InspectionStationLocations/GetAllRoadRoute?page=${page}&name=${name}`);
      
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
   //! karayolları istasyonları 3. konum ekle
   export const createInspectionThirdRoadRoute = createAsyncThunk("admin3/createInspectionThirdRoadRoute",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/InspectionStationLocations/CreateRoadRouteThirdLocation`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde eklendi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
    }
    
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });
  //! karayolları istasyonları konum silme
  export const deleteRoadRoute = createAsyncThunk("admin3/deleteRoadRoute",async (id, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(`/InspectionStationLocations/DeleteRoadRoute/${id}`);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde silindi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
      }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  //! karayolları istasyonları konum güncelleme
  // 
  export const updateRoadRoute = createAsyncThunk("admin3/updateRoadRoute",async (body, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/InspectionStationLocations/UpdateRoadRoute`, body);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde güncellendi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
      }
    
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });


  //! karayolları istasyonları 3. konum silme
  export const deleteRoadRouteThirdLocation = createAsyncThunk("admin3/deleteRoadRouteThirdLocation",async (id, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(`/InspectionStationLocations/DeleteRoadRouteThirdLocation/${id}`);
      if (data) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "Başarılı bir şekilde silindi.",
            resultType: "success",
            btnText1: "Tamam",
          })
        );
      }
      return data.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  });

  export const getTrailAndTruck = createAsyncThunk("admin3/getTrailAndTruck", async(userName,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/TruckTrailer/GetTrailerAndTruckByUserName?phoneNumber=${userName}`)

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getDegerlendirmeler = createAsyncThunk("admin3/getDegerlendirmeler", async({page, status}, thunkApi)=> {
  try {

      const {data} = await axiosInstance.get(`/Shipment/GetRateAndCommentOfTruckerShipmentFromAdmin?PageSayi=${page}&&isApproved=${status}`)

      return data
  } catch (error) {
      return thunkApi.rejectWithValue(error)
  }
})


export const yorumOnayla = createAsyncThunk("admin3/yorumOnayla", async(degerlendirme, thunkApi)=> {
  try {

      const {data} = await axiosInstance.post(`/Shipment/ApproveAddRateAndCommentToUserForShipmentAdmin`, degerlendirme)

      if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Yorum Onaylama işlemi başarıyla gerçekleştirildi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
      }
      return data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})



export const yorumReddet = createAsyncThunk("admin3/yorumReddet", async(degerlendirme, thunkApi)=> {
  try {
      const {data} = await axiosInstance.post(`/Shipment/RejectRateAndCommentToUserForShipmentAdmin`, degerlendirme)
      
      if(data.statusCode === 200){
          thunkApi.dispatch(showModal("result"))
          thunkApi.dispatch(setResultModalData({msg: "Yorum Başarıyla Reddedildi.", resultType: "success",  btnText1: "Listeyi Görüntüle"}))
      }
      return data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})



const admin3Slice = createSlice({
  name: "admin3",
  initialState,
  reducers: {
    setIslemKayitItemReqResData: (state, action) => {
      state.islemKayitItemReqResData = action.payload
    },

    setSelectPanelNotification: (state, action) => {
      state.selectPanelNotification = action.payload
    },

    setPortalMemberData: (state, action) => {
      state.portalMemberData = action.payload
      
    },

    setSelectedBlog: (state, action) => {
      state.selectedBlog = action.payload
    },

    setSelectedBlockedUserAdmin: (state, action) => {
      state.selectedBlockedUserAdmin = action.payload
    },

    //! istasyon seçimi
    setSelectedInspectionStation: (state, action) => {
      state.selectedInspectionStation = action.payload
    },
    //! istasyon konum seçimi
    setSelectedInspectionStationRoute: (state, action) => {
      state.selectedInspectionStationRoute = action.payload
    },

    clearSendCashNotificationFromExcel: (state ,action) => {
      state.sendCashNotificationFromExcelResponseList = []
      state.sendCashNotificationFromExcelResponseStatus = null
    },

    setSelectedBlogs: (state,action) => {
      state.selectedBlogs = action.payload
    }
  },
  extraReducers: (builder) => {
    builder

    //! getIslemLog
    .addCase(getIslemLog.pending, (state)=> {
      state.isLoadingGetIslemLog = true
    })

    .addCase(getIslemLog.fulfilled, (state, action) => {
      state.isLoadingGetIslemLog = false

      const safeParse = (str) => {
          try {
              return JSON.parse(str);
          } catch {
              return str;
          }
      };
  
      state.logList = action.payload.items.$values.map(item => ({
          ...item,
          requestBody: safeParse(item.requestBody),
          responseBody: safeParse(item.responseBody),
          message: safeParse(item.message)
      }));
  
      state.logDataCount = action.payload.count;
    })
  

    .addCase(getIslemLog.rejected, (state, action)=> {
      state.isLoadingGetIslemLog = false
    })


    //! getPanelUsers
    .addCase(getPanelUsers.pending, (state)=> {
      state.isLoadingPanelUsers = true
    })

    .addCase(getPanelUsers.fulfilled, (state, action)=> {
        state.panelUsers = action.payload.data.musteriListesi.$values
        state.panelUsersCount = action.payload.data.count
        state.isLoadingPanelUsers = false
    })

    .addCase(getPanelUsers.rejected, (state, action)=> {
      state.isLoadingPanelUsers = false
    })


    //! getPanelUsers
    .addCase(getPanelUsersTopluExcel.pending, (state)=> {
      state.isLoadingGetPanelUsersTopluExcel = true
    })

    .addCase(getPanelUsersTopluExcel.fulfilled, (state)=> {
        state.isLoadingGetPanelUsersTopluExcel = false
    })

    .addCase(getPanelUsersTopluExcel.rejected, (state)=> {
      state.isLoadingGetPanelUsersTopluExcel = false
    })


    //! onay bekleyenler
    .addCase(getAllRegisterDrafts.pending, (state)=> {
      state.isLoadingPanelUsers = true
    })

    .addCase(getAllRegisterDrafts.fulfilled, (state, action)=> {
        state.userDraftList = action.payload?.data?.items?.$values
        state.userDraftListCount = action.payload?.data?.count
        state.isLoadingPanelUsers = false
    })

    .addCase(getAllRegisterDrafts.rejected, (state, action)=> {
      state.isLoadingPanelUsers = false
    })

    //!updatePortalMembersControl
    .addCase(updatePortalMembersControl.pending, (state)=> {
      state.isLoadingUpdatePortalMembersControl = true
    })
    .addCase(updatePortalMembersControl.fulfilled, (state, action)=> {
        state.isLoadingUpdatePortalMembersControl = false
        state.userDraftList = state.userDraftList.map(item => {
          if(item.id === action.payload.id){
            return action.payload
          }
          else{
            return item
          }
        })
    })
    .addCase(updatePortalMembersControl.rejected, (state, action)=> {
        state.isLoadingUpdatePortalMembersControl = false
    })


    //! onay bekleyenler (onaylama yada reddetme)
    .addCase(approveRegisterDraft.pending, (state)=> {
      state.isLoadingApproveDraft = true
    })

    .addCase(approveRegisterDraft.fulfilled, (state, action)=> {
        state.isLoadingApproveDraft = false
        state.userDraftList = state.userDraftList?.filter((item) => {
          return item?.id !== action.payload.id
        })
    })

    .addCase(approveRegisterDraft.rejected, (state, action)=> {
      state.isLoadingApproveDraft = false
    })

    //! onay bekleyenler
    
    .addCase(getRentalCarSeekersAdmin.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getRentalCarSeekersAdmin.fulfilled, (state, action)=> {
        state.isLoadingGetList = false
        state.adminRentalCarSeekerList = action.payload.data.items.$values
        state.adminRentalCarSeekercount = action.payload.data.count
        
    })

    .addCase(getRentalCarSeekersAdmin.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    
    .addCase(approveRentalCarSeekerAdmin.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(approveRentalCarSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.adminRentalCarSeekerList = state.adminRentalCarSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })

    .addCase(approveRentalCarSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })

    .addCase(deleteRentalCarSeekerAdmin.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(deleteRentalCarSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminRentalCarSeekerList = state.adminRentalCarSeekerList.filter((item) => {
        return item?.id !== parseInt(action.payload.message)
      })
    })
  
    .addCase(deleteRentalCarSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })

    .addCase(updateRentalCarSeekerAdmin.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(updateRentalCarSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminRentalCarSeekerList = state.adminRentalCarSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(updateRentalCarSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    

    .addCase(getKiralikAracAdmin.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getKiralikAracAdmin.fulfilled, (state, action)=> {
        state.isLoadingGetList = false
        state.adminKiralikAracList = action.payload.data.items.$values
        state.adminKiralikAracCount = action.payload.data.count
    })

    .addCase(getKiralikAracAdmin.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })
    
    
    .addCase(adminKiralikAracAprove.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(adminKiralikAracAprove.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.adminKiralikAracList = state.adminKiralikAracList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(adminKiralikAracAprove.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })

    .addCase(adminKiralikAracDelete.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(adminKiralikAracDelete.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminKiralikAracList = state.adminKiralikAracList.filter((item) => {
        return item?.id !== parseInt(action.payload.message)
      })
    })
  
    .addCase(adminKiralikAracDelete.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })

    .addCase(adminKiralikAracUpdate.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(adminKiralikAracUpdate.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminKiralikAracList = state.adminKiralikAracList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(adminKiralikAracUpdate.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    

    //! iş arayan sürücüler
    .addCase(getDriverJobSeekerAdmin.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getDriverJobSeekerAdmin.fulfilled, (state, action)=> {
        state.isLoadingGetList = false
        state.adminDriverJobSeekerCount = action.payload.data.count
        state.adminDriverJobSeekerList = action.payload.data.items
    })

    .addCase(getDriverJobSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    .addCase(approveDriverJobSeekerAdmin.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(approveDriverJobSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.adminDriverJobSeekerList = state.adminDriverJobSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return {
            ...action.payload,
            driverJobSeekerWorkCities: action.payload.driverJobSeekerWorkCities.$values,
          }
        }else{
          return item
        }
      })
    })
  
    .addCase(approveDriverJobSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })
    
    .addCase(updateDriverJobSeekerAdmin.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(updateDriverJobSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminDriverJobSeekerList = state.adminDriverJobSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(updateDriverJobSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    
    .addCase(deleteDriverJobSeekerAdmin.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(deleteDriverJobSeekerAdmin.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminDriverJobSeekerList = state.adminDriverJobSeekerList.filter((item) => {
        return item?.id !== parseInt(action.payload.message)
      })
    })
  
    .addCase(deleteDriverJobSeekerAdmin.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    

    //!

    .addCase(adminGetSurucuArayanlar.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(adminGetSurucuArayanlar.fulfilled, (state, action)=> {
        state.isLoadingGetList = false
        state.adminDriverSeekerCount = action.payload.data.count
        state.adminDriverSeekerList = action.payload.data.items.$values
    })

    .addCase(adminGetSurucuArayanlar.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    
    .addCase(adminSurucuArayanAprove.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(adminSurucuArayanAprove.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.adminDriverSeekerList = state.adminDriverSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(adminSurucuArayanAprove.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })

    
    
    .addCase(adminSurucuArayanUpdate.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(adminSurucuArayanUpdate.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminDriverSeekerList = state.adminDriverSeekerList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(adminSurucuArayanUpdate.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    
    .addCase(adminSurucuArayanDelete.pending, (state)=> {
      state.isLoadingDelete = true
    })

    .addCase(adminSurucuArayanDelete.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      state.adminDriverSeekerList = state.adminDriverSeekerList.filter((item) => {
        return item?.id !== parseInt(action.payload.message)
      })
    })
  
    .addCase(adminSurucuArayanDelete.rejected, (state, action)=> {
      state.isLoadingDelete = false
    })
    //!

    //! satılık
    .addCase(adminGetSatilikArac.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(adminGetSatilikArac.fulfilled, (state, action)=> {
        state.isLoadingGetList = false
        state.adminSatilikAracList = action.payload.data.$values

        // state.adminSatilikAracList = action.payload.data.count
        // state.adminSatilikAracCount = action.payload.data.items.$values
    })

    .addCase(adminGetSatilikArac.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    
    .addCase(adminSatilikAracAprove.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(adminSatilikAracAprove.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.adminSatilikAracList = state.adminSatilikAracList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
  
    .addCase(adminSatilikAracAprove.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })


    //! onay bekleyenler
    .addCase(sendCashNotificationFromExcel.pending, (state)=> {
      state.isLoadingSendCashNotificationFromExcel = true
    })

    .addCase(sendCashNotificationFromExcel.fulfilled, (state, action)=> {
        state.isLoadingSendCashNotificationFromExcel = false
        state.sendCashNotificationFromExcelResponseList = action.payload.sentNotifications.$values
        state.sendCashNotificationFromExcelResponseStatus = action.payload.success
    })

    .addCase(sendCashNotificationFromExcel.rejected, (state, action)=> {
      state.isLoadingSendCashNotificationFromExcel = false
      state.sendCashNotificationFromExcelResponseStatus = action.payload.success

    })

    //! web
    
    .addCase(getBlogs.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getBlogs.fulfilled, (state, action) => {
      state.isLoadingGetList = false;
      state.webBlogList = action.payload.$values
    })
  
    .addCase(getBlogs.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    .addCase(getBlogDetail.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getBlogDetail.fulfilled, (state, action) => {
      state.isLoadingGetList = false;
      
      state.selectedBlog = {...action.payload, mainBlogs: action.payload.mainBlogs.$values, faqBlogs: action.payload.faqBlogs.$values}
    })
  
    .addCase(getBlogDetail.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    

    .addCase(createBlog.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(createBlog.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.webBlogList = [action.payload, ...state.webBlogList]
      // state.selectedBlog = action.payload
    })
  
    .addCase(createBlog.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })

    .addCase(updateBlog.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(updateBlog.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.webBlogList = state.webBlogList.map((item) => {
        if(item?.id === action.payload.id){
          return {...action.payload, mainBlogs: action.payload.mainBlogs.$values, faqBlogs: action.payload.faqBlogs.$values}
        }else {
          return item
        }
      })
      state.selectedBlog = {...action.payload, mainBlogs: action.payload.mainBlogs.$values, faqBlogs: action.payload.faqBlogs.$values}
    })
  
    .addCase(updateBlog.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })
    

    .addCase(createBlogContent.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(createBlogContent.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.selectedBlog = {...state.selectedBlog, mainBlogs: [...state.selectedBlog.mainBlogs, action.payload] }
    })
  
    .addCase(createBlogContent.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })
    
    .addCase(updateBlogContent.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(updateBlogContent.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.selectedBlog = {...state.selectedBlog, mainBlogs: state.selectedBlog.mainBlogs.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })}
    })
  
    .addCase(updateBlogContent.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })
    
    .addCase(createBlogFAQ.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(createBlogFAQ.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.selectedBlog = {...state.selectedBlog, faqBlogs: [...state.selectedBlog.faqBlogs, action.payload] }
    })
  
    .addCase(createBlogFAQ.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })
    
    .addCase(updateBlogFAQ.pending, (state)=> {
      state.isLoadingAdd = true
    })

    .addCase(updateBlogFAQ.fulfilled, (state, action) => {
      state.isLoadingAdd = false;
      state.selectedBlog = {...state.selectedBlog, faqBlogs: state.selectedBlog.faqBlogs.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })}
    })
  
    .addCase(updateBlogFAQ.rejected, (state, action)=> {
      state.isLoadingAdd = false
    })

    //! engellenen
    .addCase(addBlockedUserAdmin.pending, (state)=> {
        state.isLoadingAdd = true
    })
    .addCase(addBlockedUserAdmin.fulfilled, (state, action)=> {
        state.isLoadingAdd = false
        state.adminBlockedUsers = [...state.adminBlockedUsers , 
          {
            ...action.payload, 
            blockedUserDetails: action.payload.blockedUserDetails.$values.map((item) => {
            return {
              ...item, blockedVehicles: item.blockedVehicles.$values
            }
        })}]
    })
    .addCase(addBlockedUserAdmin.rejected, (state, action)=> {
        state.isLoadingAdd = false
        state.isErrorAddBlock = true
    })

    .addCase(getBlockedUsersAdmin.pending, (state)=> {
      state.isLoadingGetList = true
    })

    .addCase(getBlockedUsersAdmin.fulfilled, (state, action) => {
      state.isLoadingGetList = false;
      state.adminBlockedUsers = action.payload.data.items.$values.map((item) => {
        return {
          ...item,
          blockedUserDetails: item.blockedUserDetails.$values.map((inner) => {
            return {
              ...inner,
              blockedVehicles: inner.blockedVehicles.$values
            }
          })
        }
      })
      state.blockedUsersCount = action.payload.data.count
    })
  
    .addCase(getBlockedUsersAdmin.rejected, (state, action)=> {
      state.isLoadingGetList = false
    })

    
    .addCase(updateBlockedUsersAdmin.pending, (state)=> {
      state.isLoadingAdd = true
    })
    .addCase(updateBlockedUsersAdmin.fulfilled, (state, action)=> {
        state.isLoadingAdd = false
        
        state.adminBlockedUsers = state.adminBlockedUsers.map((item) => {
          if(item?.id === action.payload.id){
            return {...item, description: action.payload.description, state: action.payload.state, savedByUserAdmin: action.payload.savedByUserAdmin, isReviewed: action.payload.isReviewed, updatedAt: action.payload.updatedAt}
          }else{
            return item
          }
        })
    })
    .addCase(updateBlockedUsersAdmin.rejected, (state, action)=> {
        state.isLoadingAdd = false
        state.isErrorAddBlock = true
    })

    
    .addCase(copyBlockedUser.pending, (state)=> {
      state.isLoadingAdd = true
    })
    .addCase(copyBlockedUser.fulfilled, (state, action)=> {
        state.isLoadingAdd = false
        state.adminBlockedUsers = [...state.adminBlockedUsers , 
          {
            ...action.payload, 
            blockedUserDetails: action.payload.blockedUserDetails.$values.map((item) => {
            return {
              ...item, blockedVehicles: item.blockedVehicles.$values
            }
        })}]
    })
    .addCase(copyBlockedUser.rejected, (state, action)=> {
        state.isLoadingAdd = false
        state.isErrorAddBlock = true
    })

    //! karayolları istasyonları
    
    .addCase(getAllInspectionStationLocation.pending, (state)=> {
      state.isLoadingGetList = true
    })
    .addCase(getAllInspectionStationLocation.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionStationLocationList = action.payload
    })
    .addCase(getAllInspectionStationLocation.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! karayolları istasyonları ekleme
    .addCase(createInspectionStationLocation.pending, (state)=> {
      state.isLoadingGetList = true
    })
    .addCase(createInspectionStationLocation.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionStationLocationList = [...state.adminInspectionStationLocationList, action.payload]
    })
    .addCase(createInspectionStationLocation.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! karayolları istasyonları güncelleme
    .addCase(updateInspectionStationLocation.pending, (state)=> {
      state.isLoadingGetList = true
    })
    .addCase(updateInspectionStationLocation.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionStationLocationList = state.adminInspectionStationLocationList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
    .addCase(updateInspectionStationLocation.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! karayolları istasyonları silme
    .addCase(deleteInspectionStationLocation.pending, (state)=> {
      state.isLoadingGetList = true
    })
    .addCase(deleteInspectionStationLocation.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionStationLocationList = state.adminInspectionStationLocationList.filter((item) => {
        return item?.id !== action.payload.id
      })
    })
    .addCase(deleteInspectionStationLocation.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! karayolları istasyonları güzergah ekleme
    
    .addCase(createInspectionRoadRoute.pending, (state)=> {
      state.isLoadingAdd = true
    })
    .addCase(createInspectionRoadRoute.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionRoadRouteList = state.adminInspectionRoadRouteList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
    .addCase(createInspectionRoadRoute.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! getAllInspectionRoadRoute
    .addCase(getAllInspectionRoadRoute.pending, (state)=> {
      state.isLoadingGetList = true
    })
    .addCase(getAllInspectionRoadRoute.fulfilled, (state, action)=> {
      state.isLoadingGetList = false
      state.adminInspectionRoadRouteList = action.payload.items.$values
      state.adminInspectionRoadRouteListCount = action.payload.count
    })
    .addCase(getAllInspectionRoadRoute.rejected, (state, action)=> {
        state.isLoadingGetList = false
    })

    //! karayolları istasyonları 3. konum ekleme
    
    .addCase(createInspectionThirdRoadRoute.pending, (state)=> {
      state.isLoadingAdd = true
    })
    .addCase(createInspectionThirdRoadRoute.fulfilled, (state, action)=> {
      state.isLoadingAdd = false
      state.adminInspectionRoadRouteList = state.adminInspectionRoadRouteList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
      state.selectedInspectionStationRoute = action.payload
    })
    .addCase(createInspectionThirdRoadRoute.rejected, (state, action)=> {
        state.isLoadingAdd = false
    })
    //! karayolları istasyonları konum silme
    
    .addCase(deleteRoadRoute.pending, (state)=> {
      state.isLoadingDelete = true
    })
    .addCase(deleteRoadRoute.fulfilled, (state, action)=> {
      state.isLoadingDelete = false
      state.adminInspectionRoadRouteList = state.adminInspectionRoadRouteList.filter((item) => {
        return item?.id !== action.payload.id
      })
    })
    .addCase(deleteRoadRoute.rejected, (state, action)=> {
        state.isLoadingDelete = false
    })

    //! karayolları istasyonları 3. konum silme
    .addCase(deleteRoadRouteThirdLocation.pending, (state)=> {
      state.isLoadingDelete = true
    })
    .addCase(deleteRoadRouteThirdLocation.fulfilled, (state, action)=> {
      state.isLoadingDelete = false
      state.adminInspectionRoadRouteList = state.adminInspectionRoadRouteList.filter((item) => {
        return item?.id !== action.payload.id
      })
    })
    .addCase(deleteRoadRouteThirdLocation.rejected, (state, action)=> {
        state.isLoadingDelete = false
    })

    //! karayolları istasyonları konum güncelleme
    .addCase(updateRoadRoute.pending, (state)=> {
      state.isLoadingDelete = true
    })
    .addCase(updateRoadRoute.fulfilled, (state, action)=> {
      state.isLoadingDelete = false
      state.adminInspectionRoadRouteList = state.adminInspectionRoadRouteList.map((item) => {
        if(item?.id === action.payload.id){
          return action.payload
        }else{
          return item
        }
      })
    })
    .addCase(updateRoadRoute.rejected, (state, action)=> {
        state.isLoadingDelete = false
    })

    // get trail and truck
    .addCase(getTrailAndTruck.pending, (state)=> {
        state.statusCode = null
        state.isLoading = true
    })

    .addCase(getTrailAndTruck.fulfilled, (state, action)=> {
        state.isLoading = false
        state.trailers = action.payload.data.trailers.$values
        state.trucks = action.payload.data.trucks.$values
    })

    .addCase(getTrailAndTruck.rejected, (state, action)=> {
        state.isLoading = false
        state.isError = true
        state.errMessage = true
    })


    .addCase(getDegerlendirmeler.pending, (state)=> {
        state.isLoading = true
        state.sevkiyatList = null
        state.sevkiyatCount = null
    })

    .addCase(getDegerlendirmeler.fulfilled, (state, action)=> {
        state.isLoading = false
        state.degerlendirmelerList = action.payload.data.$values
    })

    .addCase(getDegerlendirmeler.rejected, (state, action)=> {
        state.isLoading = false
        state.isError = true
        state.errMessage = true
    })


    .addCase(yorumOnayla.pending, (state)=> {
      state.isLoading = true
      state.sevkiyatList = null
      state.sevkiyatCount = null
  })

  .addCase(yorumOnayla.fulfilled, (state, action)=> {
      state.isLoading = false
      state.degerlendirmelerList = state.degerlendirmelerList.filter((item) => {
          return item.shipmentId !== action.payload.data.shipmentId
      })
  })

  .addCase(yorumOnayla.rejected, (state, action)=> {
      state.isLoading = false
      state.isError = true
      state.errMessage = true
  })


  .addCase(yorumReddet.pending, (state)=> {
      state.isLoading = true
      state.sevkiyatList = null
      state.sevkiyatCount = null
  })

  .addCase(yorumReddet.fulfilled, (state, action)=> {
      state.isLoading = false
      state.degerlendirmelerList = state.degerlendirmelerList.filter((item) => {
          return item.shipmentId !== action.payload.data.shipmentId
      })
  })

  .addCase(yorumReddet.rejected, (state, action)=> {
      state.isLoading = false
      state.isError = true
      state.errMessage = true
  })


  .addCase(deleteBlog.pending, (state)=> {
      state.isLoadingDeleteBlog = true
  })

  .addCase(deleteBlog.fulfilled, (state, action)=> {
      state.isLoadingDeleteBlog = false
      const deletedIds = action.payload.$values
      state.selectedBlogs = state.selectedBlogs.filter(it => !deletedIds.includes(it.id))
      state.selectedBlog = null
      state.webBlogList = state.webBlogList.filter(it => !deletedIds.includes(it.id))
  })

  .addCase(deleteBlog.rejected, (state, action)=> {
      state.isLoadingDeleteBlog = false
  })
  
  },
});


export const {
  setSelectedInspectionStationRoute,
  setPortalMemberData,
  setSelectedBlockedUserAdmin,
  setIslemKayitItemReqResData,
  setSelectPanelNotification,
  clearSendCashNotificationFromExcel,
  setSelectedBlog,
  setSelectedInspectionStation,
  setSelectedBlogs
} = admin3Slice.actions;
export default admin3Slice.reducer;
